import { render, staticRenderFns } from "./pdfdemo.vue?vue&type=template&id=021a2711&scoped=true&"
import script from "./pdfdemo.vue?vue&type=script&lang=js&"
export * from "./pdfdemo.vue?vue&type=script&lang=js&"
import style0 from "./pdfdemo.vue?vue&type=style&index=0&id=021a2711&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a2711",
  null
  
)

export default component.exports